/*
 * @LastEditors: whb
 * @LastEditTime: 2023-01-13 10:48:32
 * @Description: 
 * @FilePath: /starmaker-starvr-officialnew/src/utils/index.js
 */

export function getParam(name) {
  // var reg = new RegExp(
  //   "(\\?|&)" + name + "=([^&]*)(&|$)"
  // );
  // var r = decodeURIComponent(window.location.search).match(reg);
  // if (r != null) {
  //   return decodeURIComponent(r[2]);
  // }
  // return "";


  var search = window.location.search.substr(1) || window.location.hash.split("?")[1];
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = search && search.match(reg);
  if (r != null) return unescape(r[2]); return null;
}
export function getUUID() {
  let d = Date.now();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  let i = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return i;
}
export function debounce(fun, delay, scope) {
  return function (args) {
    let that = scope || this;
    let _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay || 300);
  };
}